export const ORDER_STATUS_LABELS = {
  draft: 'Rascunho',
  pending: 'Aguardando pagamento',
  confirmed: 'Confirmado',
  in_progress: 'Em andamento',
  ready: 'Pronto',
  fulfilled: 'Concluído',
  cancelled: 'Cancelado',
  expired: 'Expirado'
};

export const ORDER_STATUS_TONES = {
  draft: 'neutral',
  pending: 'warning',
  confirmed: 'primary',
  in_progress: 'info',
  ready: 'info',
  fulfilled: 'success',
  cancelled: 'neutral',
  expired: 'danger'
};

export const ORDER_PAYMENT_STATUS_LABELS = {
  unpaid: 'Não pago',
  paid: 'Pago',
  refunded: 'Reembolsado'
};

export const ORDER_PAYMENT_STATUS_TONES = {
  unpaid: 'warning',
  paid: 'success',
  refunded: 'danger'
};

export const CHARGE_STATUS_LABELS = {
  creating: 'gerando no provedor',
  pending: 'aguardando pagamento',
  unknown: 'sem confirmação do provedor',
  paid: 'paga',
  failed: 'recusada pelo provedor',
  expired: 'expirada',
  cancelled: 'cancelada',
  refunded: 'reembolsada'
};

export const CHARGE_CANCELLATION_NOTES = {
  cancelled: 'cobrança cancelada no provedor',
  closed: 'cobrança já estava encerrada',
  not_supported: 'cobrança segue ativa no provedor, que não permite cancelá-la pela API'
};

export const ORDER_TRANSITIONS = {
  draft: ['confirmed', 'cancelled'],
  pending: ['confirmed', 'cancelled'],
  confirmed: ['in_progress', 'ready', 'fulfilled', 'cancelled'],
  in_progress: ['ready', 'fulfilled', 'cancelled'],
  ready: ['fulfilled', 'cancelled'],
  fulfilled: [],
  cancelled: [],
  expired: []
};

export const ORDER_ACTION_LABELS = {
  confirmed: 'Confirmar',
  in_progress: 'Iniciar atendimento',
  ready: 'Marcar como pronto',
  fulfilled: 'Concluir'
};

export const ORDER_EVENT_LABELS = {
  placed: 'Pedido criado com reserva',
  payment_confirmed: 'Pagamento confirmado',
  confirmed_by_payment: 'Confirmado pelo pagamento',
  confirmed_free: 'Confirmado (sem valor a pagar)',
  reinstated_by_payment: 'Reativado pelo pagamento',
  capacity_conflict: 'Pago sem vaga disponível: resolver manualmente',
  payment_refunded: 'Pagamento reembolsado',
  status_changed: 'Status alterado',
  cancelled: 'Cancelado',
  hold_expired: 'Reserva expirada',
  confirmation_sent: 'Confirmação e vouchers enviados ao cliente',
  vouchers_issued: 'Vouchers e ingressos emitidos',
  vouchers_cancelled: 'Vouchers e ingressos cancelados',
  vouchers_issue_failed: 'Falha ao emitir vouchers e ingressos (nova tentativa automática)'
};

export const FULFILLMENT_LABELS = {
  delivery: 'Entrega',
  pickup: 'Retirada',
  on_site: 'Presencial',
  digital: 'Digital'
};
